import { useEffect, useCallback } from 'react';

import { RINGOVER_CURRENT_CONTACT_CALL } from '../../utils/ringoverEvents';

const ManageTabs = () => {
  const ongletID = `${new Date().getTime()}-${Math.random()
    .toString(36).substring(2, 9)}`;

  const manageTabs = useCallback((action) => {
    let arrayTabs = JSON.parse(localStorage.getItem('tabs')) || [];

    if (action === 'add') {
      arrayTabs = arrayTabs.map(tab => ({ ...tab, active: false }));
      arrayTabs.push({ id: ongletID, active: true });
    } else if (action === 'delete') {
      arrayTabs = arrayTabs.filter(tab => tab.id !== ongletID);
      if (!arrayTabs.some((tab) => tab.active)) {
        arrayTabs[arrayTabs.length - 1].active = true;
      }
    }

    localStorage.setItem('tabs', JSON.stringify(arrayTabs));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    manageTabs('add');

    const deleteActiveTab = () => manageTabs('delete');

    const handleCurrentContact = (e) => {
      const tabs = JSON.parse(localStorage.getItem('tabs')) || [];
      if (tabs.find(tab => tab.active && tab.id === ongletID)) {
        window.open(e.detail.data.page, '_blank');
      }
    };

    window.addEventListener('unload', deleteActiveTab);
    window.addEventListener(
      RINGOVER_CURRENT_CONTACT_CALL, handleCurrentContact
    );

    return () => {
      window.removeEventListener('unload', deleteActiveTab);
      window.removeEventListener(
        RINGOVER_CURRENT_CONTACT_CALL, handleCurrentContact
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default ManageTabs;
